export const MenuIconCustom = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 16 16"
      fill="none"
      className="css-1170n61"
    >
      <rect x="1" y="5" width="14" height="1.5" rx="1" fill="#1A4DBE"></rect>
      <rect x="1" y="9" width="14" height="1.5" rx="1" fill="#1A4DBE"></rect>
    </svg>
  );
};
